import { Api, ConfigHelper } from 'relapp-api';

export default {
    /**
     * Get the hosting sso url.
     *
     * @param {string} domain
     *
     * @return {Promise}
     */
    createSSOLink(domain) {
        const url = ConfigHelper.apiUrl('hosting.sso', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.get(url);
    },

    /**
     * Get customer config
     *
     * @param {string} domain
     * @returns {Promise}
     */
    customerConfig(domain) {
        const url = ConfigHelper.apiUrl('hosting.customer-config', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.get(url);
    },

    /**
     *
     * @param {string} domain
     * @param {object} changes
     *
     * @returns {Promise}
     */
    modifyCustomer(domain, changes) {
        const url = ConfigHelper.apiUrl('hosting.modify-customer', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.put(url, changes);
    },

    /**
     * Reset password for a hosting package
     *
     * @param {string} domain
     *
     * @return {Promise}
     */
    resetPassword(domain) {
        const url = ConfigHelper.apiUrl('hosting.reset', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.get(url);
    },

    showUserStatistics(domain) {
        const url = ConfigHelper.apiUrl('hosting.stats', [
            {
                key: '{domain}',
                value: domain
            }
        ]);

        return Api.get(url);
    }
};
